import React, { Fragment } from 'react';
import { Field } from 'redux-form';
import { Grid } from 'semantic-ui-react';

import { SelectField, InputField } from 'Common/SemanticWrapper';
import { OrderPreferenceEnum } from 'Common/FieldEnum';
import DayDropDown from 'Common/Components/DayDropDown/DayDropDown';
import { SelectFieldWithAddRemoveContainer } from 'Components/selectFieldWithAddRemove/container';
import { TitledCard } from 'Components';
import { makeOptionsDataRemoveEmpty, makeOptionsData } from 'Common/FormHelper';
import { ORDER_PREFERENCE_OPTIONS } from 'Common/Constants';

const WarehouseAndStapleForm = props => {
  const {
    storageLocationOptions = [],
    siteGroupWHData = [],
    selectedRowInfo,
    onFieldChange,
    removeWarehouseKit
  } = props;
  return (
    <Fragment>
      <TitledCard title={'Order Preference'} style={{ padding: 0 }}>
        <Grid>
          <Grid.Row>
            <Grid.Column style={{ paddingLeft: '1.4rem' }} width={12}>
              <Field
                name={OrderPreferenceEnum.OrderPreferenceId}
                component={SelectField}
                options={ORDER_PREFERENCE_OPTIONS}
                onChange={onFieldChange}
                disabled={!selectedRowInfo}
              />
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </TitledCard>
      <TitledCard title={'Warehouse(s)/Kitchen'} style={{ padding: 0 }}>
        <Grid>
          <Grid.Row>
            <Grid.Column className="warehouseKitchenWidget">
              <Field
                name={OrderPreferenceEnum.WarehouseKitchen}
                component={SelectFieldWithAddRemoveContainer}
                {...{
                  dataSource: siteGroupWHData
                    ? makeOptionsDataRemoveEmpty(removeWarehouseKit(siteGroupWHData), true)
                    : [],
                }}
                onChange={onFieldChange}
                disabled={!selectedRowInfo}
              />
            </Grid.Column>
          </Grid.Row>
        </Grid>
        <TitledCard title={'Staples'} style={{ padding: 0 }}>
          <Grid className="tight">
            <Grid.Row columns={3}>
              <Grid.Column>
                <DayDropDown
                  name={OrderPreferenceEnum.StapleDayOfWeekId}
                  disabled={!selectedRowInfo}
                  onChange={onFieldChange}
                />
              </Grid.Column>
              <Grid.Column>
                <Field
                  name={OrderPreferenceEnum.StapleStorageLocationId}
                  component={SelectField}
                  label={'Storage Location'}
                  options={
                    storageLocationOptions
                      ? makeOptionsData(storageLocationOptions)
                      : []
                  }
                  disabled={!selectedRowInfo}
                  onChange={onFieldChange}
                />
              </Grid.Column>
              <Grid.Column>
                <Field
                  name={OrderPreferenceEnum.StapleRoute}
                  component={InputField}
                  type="text"
                  label={'Route'}
                  maxLength={15}
                  disabled={!selectedRowInfo}
                  onChange={onFieldChange}
                />
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </TitledCard>
      </TitledCard>
    </Fragment>
  );
};

export default WarehouseAndStapleForm;



// WEBPACK FOOTER //
// ./src/pages/utilities/assignorderpreference/components/WarehouseAndStapleForm.js